import React from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageBreadcrumbs from '../components/Breadcrumbs';

const BillingInfo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm">
      <Box mt={4}>
        <PageBreadcrumbs
          items={[
            { label: t('nav.dashboard'), path: '/dashboard' },
            { label: t('nav.billingStore') },
          ]}
        />
        <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom>
              {t('billing.info.title', 'Access blocked - no subscription')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('billing.info.description', 'Your organization does not have an active subscription. Contact your organization administrator.')}
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default BillingInfo;
